module.exports = __webpack_public_path__ + "static/media/administration-smart.eb81db74.svg";